import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DesignerSkill } from 'src/common/common.interface'

export interface DesignerSkillState {
  designerSkills?: DesignerSkill[]
  countDesignerSkill: number
  isLoadingGetDesignerSkills: boolean
}

const initialState: DesignerSkillState = {
  designerSkills: undefined,
  countDesignerSkill: 0,
  isLoadingGetDesignerSkills: false
}

const designerSkillSlice = createSlice({
  name: 'designerSkill',
  initialState,
  reducers: {
    setDesignerSkillsData(state, action: PayloadAction<DesignerSkill[]>) {
      state.designerSkills = action.payload
    },
    setCountDesignerSkills(state, action: PayloadAction<number>) {
      state.countDesignerSkill = action.payload
    },
    setIsLoadingGetDesignerSkills(state, action: PayloadAction<boolean>) {
      state.isLoadingGetDesignerSkills = action.payload
    }
  }
})

export const designerSkillAction = designerSkillSlice.actions

export default designerSkillSlice.reducer
